const CASE_QUANTITY_BY_NDC = new Map<string, number>([
  ["55150027801", 48],
  ["55150027701", 48],
]);

function normalizeNdc(ndc: string | null | undefined): string {
  return String(ndc ?? "").replace(/\D/g, "");
}

export function getCaseQuantity(ndc: string | null | undefined): number | null {
  return CASE_QUANTITY_BY_NDC.get(normalizeNdc(ndc)) ?? null;
}

export function toSellableUnitQuantity(
  requestedUnits: number,
  ndc: string | null | undefined,
): number {
  const quantity = Math.max(1, Math.floor(requestedUnits) || 1);
  const caseQuantity = getCaseQuantity(ndc);
  if (!caseQuantity) return quantity;
  return Math.ceil(quantity / caseQuantity) * caseQuantity;
}

export function caseCountToUnits(
  caseCount: number,
  ndc: string | null | undefined,
): number {
  const count = Math.max(1, Math.floor(caseCount) || 1);
  return count * (getCaseQuantity(ndc) ?? 1);
}

export function getAvailableSellableUnits(
  availableUnits: number,
  ndc: string | null | undefined,
): number {
  const available = Math.max(0, Math.floor(availableUnits) || 0);
  const caseQuantity = getCaseQuantity(ndc);
  if (!caseQuantity) return available;
  return Math.floor(available / caseQuantity) * caseQuantity;
}

export function unitQuantityToCases(
  units: number,
  ndc: string | null | undefined,
): number {
  const caseQuantity = getCaseQuantity(ndc);
  if (!caseQuantity) return units;
  return Math.ceil(units / caseQuantity);
}